import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const LoginIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M8.42 5.72V4.08H18.78V19.84H8.42V18.2H17.14V5.72H8.42ZM4.44 12.8V11.12H12.72L10.34 8.76L11.42 7.68L15.7 11.96L11.42 16.24L10.34 15.16L12.72 12.8H4.44Z" />
    </SvgIcon>
  );
});
